import React, { useState } from "react";
import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";
import { Box, Grid, Typography } from "@material-ui/core";
import { toast } from "react-toastify";
import { modal, formatDatetime } from "../../../../util";
import { Link } from "react-router-dom";
import ProductCategory from "./productCategoryForm";
import DragAndDropTable from "../../../common/DragAndDropTable";

export default function ProductCategoryPage(props) {
  const { disabled, match } = props;
  const [globalFilter, setGlobalFilter] = useState("");
  const [isSearched, setIsSearched] = useState(false);
  const [orderingDisabled, setOrderingDisabled] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchString, setSearchString] = useState("");
  const { setLoading } = useLoading();
  const [pageSize, setPageSize] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const getProductCategories = React.useCallback(async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getProductCategories(
        null,
        pageIndex,
        (pageIndex + 1) * pageSize,
        pageSize,
        searchString
      );
      console.log(result);
      setRows(result.data.content.filter((x) => x));
      setTotalElements(result.data.totalElements);
      setTotalPages(result.data.totalPages);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [pageIndex, pageSize, searchString, setLoading]);

  React.useEffect(() => {
    if (pageSize) getProductCategories();
  }, [getProductCategories]);

  const handleSorting = (bool) => {
    if (!isSearched) {
      setOrderingDisabled(bool);
    }
  };

  const handleSearch = (searchString) => {
    setGlobalFilter(searchString);
    setIsSearched(true);
    setOrderingDisabled(true);
  };

  const handleDelete = async (id) => {
    const decision = await modal.fire({
      title: "Delete File",
      text: "Are you sure to delete this category?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        await apiHelper.hkiff.deleteProductCategoryById(id);
        toast.dark("The category is deleted.");
        await getProductCategories();
      } catch (err) {
        console.log(err);
      }
    }
  };

  const bulkDelete = (ids) => {
    const promises = ids.map((id) => apiHelper.hkiff.deleteProductCategoryById(id));
    return Promise.all(promises);
  };

  const getMaxSeqInRows = (rows) => {
    let seq = null;
    rows.forEach((e) => {
      if ((e.seq && seq === null) || (seq !== null && e.seq > seq)) {
        seq = e.seq
      }
    })
    return seq;
  }

  const saveOrdering = async () => {
    try {
      const maxSeq = getMaxSeqInRows(rows);
      const seqData = {};
      rows.forEach((e, i) => {
        seqData[e.id] = maxSeq - i;
      });

      console.log(seqData);
      const result = await apiHelper.hkiff.orderProductCategories(seqData);
      if (result.data.code === 0) {
        toast.dark("Your changes is saved.");
        await getProductCategories();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const columns = React.useMemo(
    () => [
      // {
      //   Header: "ID",
      //   accessor: "id",
      //   Cell: ({ row }) => {
      //     return (
      //       <Link
      //         style={{
      //           textDecoration: "none",
      //           color: "#306F9D",
      //         }}
      //         to={`${match.url}/${row.original.id}`}
      //       >
      //         {row.original.id}
      //       </Link>
      //     );
      //   },
      // },
      // {
      //   Header: "SEQ",
      //   accessor: "seq",
      //   Cell: ({ row }) => {
      //     return (
      //       <Link
      //         style={{
      //           textDecoration: "none",
      //           color: "#306F9D",
      //         }}
      //         to={`${match.url}/${row.original.id}`}
      //       >
      //         {row.original.seq}
      //       </Link>
      //     );
      //   },
      // },
      {
        Header: "Type",
        accessor: "type",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.type}
            </Link>
          );
        },
      },
      {
        Header: "Name (English)",
        accessor: "nameEn",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.nameEn}
            </Link>
          );
        },
      },
      {
        Header: "Name (Traditional Chinese)",
        accessor: "nameTc",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.nameTc}
            </Link>
          );
        },
      },
      {
        Header: "No. of Items",
        accessor: "itemNo",
      },
    ],
    []
  );

  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
        eShop &gt; Product Category
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <ProductCategory
            description="Add New Category"
            submitBtnTxt="Add New Category"
            upperBtnGroupSize="50%"
            history={props.history}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={8}>
          <DragAndDropTable
            globalFilter={globalFilter}
            orderingDisabled={orderingDisabled}
            handleSorting={handleSorting}
            handleSearch={handleSearch}
            searchString={searchString}
            setSearchString={setSearchString}
            fetchData={getProductCategories}
            data={rows}
            setData={setRows}
            columns={columns}
            bulkDeleteApi={bulkDelete}
            subject="category"
            saveOrderingApi={saveOrdering}
            disabled={disabled}
            editDeleteAction={true}
            handleDelete={handleDelete}
            withPagination={true}
            setParentPageSize={setPageSize}
            setParentPageIndex={setPageIndex}
            parentPageIndex={pageIndex}
            totalElements={totalElements}
            totalPages={totalPages}
          />
        </Grid>
      </Grid>
    </>
  );
}
